import styled from '@emotion/styled';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const Section = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SearchSection = styled(Section)`
  background-color: #8940fa;
`;

const SearchSectionBackground = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  background: linear-gradient(
      345deg,
      rgba(0, 0, 0, 0.1) 15%,
      rgba(0, 0, 0, 0) 9%
    ),
    linear-gradient(328deg, rgba(0, 0, 0, 0) 95%, rgba(0, 0, 0, 0.1) 93%);
`;

const SearchContent = styled.div`
  width: 100%;
  max-width: 1015px;
  padding: 0 30px;
`;

const PodcastSection = styled(Section)`
  background-color: #ebeced;
  padding: 104px 30px;
`;

const PodcastContent = styled.div`
  max-width: 900px;
`;

const WhySwitchSection = styled(Section)`
  background-color: #f4f4f5;
  padding: 104px 30px;
`;

const WhySwitchContent = styled.div`
  max-width: 950px;
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
`;

const ListContainer = styled.div`
  max-width: 450px;
  width: 100%;
`;

const List = styled.ul`
  list-style: none;
  padding-left: 0;

  li {
    display: flex;
    align-items: center;
    margin: 12px 0;

    &:before {
      background-color: #884af6;
      border-radius: 50%;
      content: '';
      display: inline-block;
      margin-right: 20px;
      margin-bottom: 2px;
      height: 8px;
      width: 8px;
      padding: 0 4px;
    }
  }
`;

const ImageContainer = styled.div`
  max-width: 459px;
  padding-top: 25px;
`;

const HowToSwitchSection = styled(Section)`
  background-color: #f9f9f9;
`;

const HowToSwitchContent = styled.div`
  max-width: 1000px;
  width: 100%;
  padding: 100px 0;
`;

const Video = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 65px;
`;

const StepsContainer = styled.div`
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
`;

const StepContainer = styled.div`
  width: 230px;
  margin: 15px 10px;
`;

const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
`;

const StepTitle = styled.div`
  margin-bottom: 8px;
`;

const QuotesSection = styled(Section)`
  background-color: #ebeced;
  padding: 100px 30px;
`;

const QuotesContent = styled.div`
  max-width: 966px;
`;

const QuotesContainer = styled.div`
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
`;

const QuoteContainer = styled.div`
  width: 300px;
  background-color: #ffffff;
  height: 260px;
  margin: 13px 11px;
  padding: 20px;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
`;

const QuoteHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  width: 100%;
`;

const QuoteImage = styled.div`
  width: 50px;
`;

const QuoteTitle = styled.div`
  width: 100%;
  padding-left: 18px;
`;

const Quote = styled.div`
  width: 100%;
  min-height: 137px;
`;

const QuoteIconContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;
const QuoteIcon = styled.div`
  width: 34px;
`;

const FaqSection = styled(Section)`
  background-color: #8940fa;
`;

const FaqBackground = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 70px 30px;
  background: linear-gradient(
      321deg,
      rgba(0, 0, 0, 0.1) 2%,
      rgba(0, 0, 0, 0) -3%
    ),
    linear-gradient(335deg, rgba(0, 0, 0, 0) 89%, rgba(0, 0, 0, 0.2) 84%),
    linear-gradient(326deg, rgba(0, 0, 0, 0) 97%, rgba(0, 0, 0, 0.2) 93%);
`;

const FaqContent = styled.div`
  max-width: 780px;
`;

export {
  Container,
  SearchSection,
  SearchSectionBackground,
  SearchContent,
  PodcastSection,
  PodcastContent,
  WhySwitchSection,
  WhySwitchContent,
  ListContainer,
  List,
  ImageContainer,
  HowToSwitchSection,
  HowToSwitchContent,
  Video,
  StepsContainer,
  StepContainer,
  IconContainer,
  StepTitle,
  QuotesSection,
  QuotesContent,
  QuotesContainer,
  QuoteContainer,
  QuoteHeader,
  QuoteImage,
  QuoteTitle,
  Quote,
  QuoteIconContainer,
  QuoteIcon,
  FaqSection,
  FaqBackground,
  FaqContent,
};
